import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  warningList: [],
  alignFace: false,
  noOfMultiFace: 0,
  multiFaceLapseTimeInSec: 2,
  multiFace: false,
  multiFaceCount: 0,
};

export const warningSlice = createSlice({
  name: "warning",
  initialState,
  reducers: {
    addWarning: (state, action) => {
      state.warningList.push(action.payload);
    },
    removeWarning: (state, action) => {
      delete state.warningList[action.payload.index];
    },
    updateAlignFace: (state, action) => {
      state.alignFace = action.payload;
    },
    updateMultiFaceNo: (state) => {
      const { noOfMultiFace } = state;
      state.noOfMultiFace = noOfMultiFace + 1;
    },
    setMultiFace: (state, action) => {
      state.multiFace = action.payload;
    },
    multiFaceCounter: (state) => {
      const { multiFace, multiFaceCount } = state;
      if (multiFace) {
        state.multiFaceCount = multiFaceCount + 1;
      } else {
        state.multiFaceCount = 0;
      }
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  addWarning,
  removeWarning,
  setMultiFace,
  updateAlignFace,
  updateMultiFaceNo,
  multiFaceCounter,
} = warningSlice.actions;

export default warningSlice.reducer;
